import { render, staticRenderFns } from "./activityManage.vue?vue&type=template&id=0dc6776a&scoped=true&"
import script from "./activityManage.vue?vue&type=script&lang=js&"
export * from "./activityManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc6776a",
  null
  
)

export default component.exports